<template>
  <div class="tw:flexrow-1 tw:items-center tw:justify-between">
    <div class="tw:flexrow-1 tw:items-center tw:min-w-0">
      <v-checkbox
        :input-value="metadata.isVisible"
        hide-details
        :ripple="false"
        class="tw:m-0 tw:p-0 tw:[&_.v-input--selection-controls\_\_input]:m-0"
        @change="toggleVisibility"
      ></v-checkbox>
      <div>
        <layer-style-preview-icon v-bind="layerIconBind" />
      </div>
      <div class="tw:text-sm tw:truncate">{{ metadata.name }}</div>
    </div>
    <div class="tw:flexrow-0.5">
      <v-tooltip v-for="action in actions" :disabled="!action.tooltip" :key="action.name" bottom color="font">
        <template #activator="{ on: onTooltip }">
          <v-btn @click="handleAction(action.name)" small icon v-on="onTooltip">
            <v-icon color="iconIdle">{{ action.icon }}</v-icon>
          </v-btn>
        </template>
        {{ action.tooltip }}
      </v-tooltip>
      <dots-menu :items="[{ name: 'delete' }]" @delete="removeLayer" />
    </div>
  </div>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
import LayerStylePreviewIcon from '@/components/LayerStylePreviewIcon';

export default {
  name: 'TemporaryLayersListItem',
  components: {
    DotsMenu,
    LayerStylePreviewIcon,
  },
  props: {
    metadata: {
      type: Object,
      required: true,
    },
  },
  computed: {
    actions() {
      return [
        {
          name: 'zoom',
          icon: 'mdi-fullscreen',
          tooltip: this.$i18n.t('button.zoomToLayer'),
        },
      ];
    },
    layerIconBind() {
      return {
        layerType: this.metadata.geometry_type,
        layerStyle: this.metadata.style,
        isIcon: true,
        hideColorPicker: true,
      };
    },
  },
  methods: {
    handleAction(name) {
      switch (name) {
        case 'zoom':
          return this.zoomToLayer();
        default:
          throw new Error(`Action ${name} not recognized`);
      }
    },
    zoomToLayer() {
      this.$root.$emit('zoomToCustomLayer', this.metadata.id, 'temporaryLayers');
    },
    removeLayer() {
      this.$root.$emit('removeTemporaryLayer', this.metadata.id);
    },
    toggleVisibility(e) {
      this.$root.$emit('alterTemporaryLayer', this.metadata.id, 'visibility', e);
    },
  },
};
</script>
